import { useProfileContext } from "../context/ProfileContext";

const useProfileDeletion = () => {
  const { deleteProfile } = useProfileContext(); // Use the deleteProfile function from context

  const handleProfileDeletion = (profileValue) => {
    if (!profileValue) {
      console.error("Invalid profile value");
      return;
    }
    deleteProfile(profileValue); // Call the context's deleteProfile function
    alert("Profile deleted successfully!");
  };

  return { handleProfileDeletion };
};

export default useProfileDeletion;
